import { ContentType } from 'libs/shared/src/models';
import { GsFormFieldSelect, GsFormSchema } from '../../../../components';
import { generateSwiperSchemaFields } from '../../basics';
import { ZOOM_SCHEMA_FIELDS } from '../../basics/zoom.schema';
import { ARTICLE_INFO_BASE_FORM_SCHEMA, ARTICLE_INFO_THUMBNAILS_POSITION_SCHEMA } from './base/article-info-base.schema';

export const ARTICLE_INFO_CEMETERY_COMPONENT_FORM_SCHEMA: GsFormSchema = {
  fields: [
    ...ARTICLE_INFO_BASE_FORM_SCHEMA,
    ...ARTICLE_INFO_THUMBNAILS_POSITION_SCHEMA,
    ...generateSwiperSchemaFields(false, []),
    ...ZOOM_SCHEMA_FIELDS,
    {
      formControlName: 'segmentBars',
      label: 'components.articleInfo.schema.infoTabs',
      type: 'object-list',
      default: [],
      maxObjectsAmount: 6,
      objectSchema: {
        fields: [
          {
            formControlName: 'name',
            label: 'components.articleInfo.schema.name',
            type: 'text',
            labelPosition: 'left',
            default: 'Tab'
          },
          {
            formControlName: 'contentType',
            label: 'components.articleInfo.schema.contentType',
            type: 'select',
            default: 'details',
            labelPosition: 'left',
            options: [
              { text: 'components.articleInfo.schema.options.details', value: 'details' },
              { text: 'components.articleInfo.schema.options.description', value: 'description' },
              { text: 'components.articleInfo.schema.options.texts', value: 'texts' },
              { text: 'components.articleInfo.schema.options.detailsWithPictograms', value: 'detailsWithPictograms' },
              { text: 'components.articleInfo.schema.options.purchaseArguments', value: 'purchaseArguments' },
              { text: 'components.articleInfo.schema.options.articleProperties', value: 'articleProperties' },
              { text: 'components.articleInfo.schema.options.pictoGrid', value: 'pictoGrid' },
              { text: 'components.articleInfo.schema.options.faq', value: 'faq' },
              { text: 'components.articleInfo.schema.options.ratings', value: 'ratings' }
            ]
          } as GsFormFieldSelect<ContentType>,
          {
            formControlName: 'sortIndex',
            label: 'components.articleInfo.schema.sortIndex',
            type: 'number',
            labelPosition: 'left',
            min: 0,
            default: 0
          }
        ]
      }
    }
  ]
};
